$(document).on("click",".click-add-to-card",function(){
  console.log("click click-add-to-card",$(this).data("variant-id"))
  $.ajax({
    method : "POST",
    type: "POST",
    dataType: "json",
    url: "/cart/add.js",
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    data : JSON.stringify({    
      items: [
        {
          quantity: 1,
          id: $(this).data("variant-id").toString()
        }
      ]
    }),
    success : function(kq){
    	window.location.href = "/cart"
    },
    error : function(kq){
    	
    },
  })
})
$(document).on("click",".click-to-remove-cart",function(){
	const id = $(this).data("id");
    $.ajax({
      method : "POST",
      dataType:"json",
      type: "POST",
      url: "/cart/update.js",
      
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      data : JSON.stringify({    
        updates : {
          [id] : 0
        }
      }),
      success : function(kq){
          window.location.href = "/cart"
      },
      error : function(kq){

      },
    })
})
$(document).on("click",".cart-notification-container-close",function(){
  $(".cart-notification-container").hide();
  
	
})
$(document).on("click",".remove-all-item",function(){
  $.ajax({
    method : "POST",
    type: "POST",
    dataType: "json",
    url: "/cart/clear.js",
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    success : function(kq){
    	window.location.href = "/cart"
    },
    error : function(kq){
    	
    },
  })
});
$(document).on("click","#cart-icon-bubble",function(){
  	console.log("test")
	$(".cart-notification-container").show();
})
$(document).ready(function(){
loadCartPopup();
})
function loadCartPopup(open = false){
  let str = ``;
  $.ajax({
    type : "GET",
    dataType:"json",
    method: "GET",
    url: "/cart.js",
    success : function(kq){
      	let items = kq.items || []
        items.map((item,index)=>{
           str += `
        	<div class="cart-item">
                <div class="cart-item-image">
                	<img src="${item.image}"  alt="" />
                </div>
                <div class="cart-item-content">
                  <div><a href="${item.url}">${item.title}</a></div>
                  <div class="cart-item-info">
                    <div class="cart-item-info-money">
						<div>Price: ${Math.round(item.price/100)}</div>
						<div>QTY: ${item.quantity}</div>
					</div>
                    <div class="cart-item-info-trash">
                      <cart-remove-button id="Remove-${index+1}" data-index="${index+1}">
                        <a href="javascript:void(0)" data-id="${item.variant_id}" class="button button--tertiary click-to-remove-cart">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                            <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                            <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                          </svg>
                                                  
						</a>
                      </cart-remove-button>
                    </div>
                  </div>
                </div>
              </div>
            `    
        })
		$(".cart-notification-items").html(str);
      	if(open) $(".cart-notification-container").show();
    }
  
  })
}
        